module.exports = __webpack_public_path__ + "img/om_qr_douyin.d1a02fea.png";